import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useRef } from 'react';
export default function useFocusing(_ref) {
  var _ref$day = _slicedToArray(_ref.day, 2),
      dayValue = _ref$day[0],
      setDayValue = _ref$day[1],
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus;

  var dateRef = useRef({
    day: dayValue
  });
  useEffect(function () {
    dateRef.current = {
      day: dayValue
    };
  }, [dayValue]);
  var handleContainerBlur = useCallback(function (event) {
    setDayValue(0);
    onBlur(event);
  }, [setDayValue, onBlur]);
  var handleContainerFocus = useCallback(function (event) {
    setDayValue(dateRef.current.day || 1);
    onFocus(event);
  }, [setDayValue, onFocus]);
  return {
    handleContainerBlur: handleContainerBlur,
    handleContainerFocus: handleContainerFocus
  };
}